<div class="flex flex-col w-full">
  <p class="text-2xl font-bold pb-6">Drucker</p>

  <div [ngClass]="{
  'xl:grid-cols-3': !PermissionService.CheckPermission(PermissionService.Device_Printer_Add()),
  'xl:grid-cols-4': PermissionService.CheckPermission(PermissionService.Device_Printer_Add())
  }" class="w-full grid grid-cols-1 space-x-4 items-start">
    <div *ngIf="PermissionService.CheckPermission(PermissionService.Device_Printer_Add())"
         class="col-span-1 p-4 flex rounded-lg shadow-xl flex-col">
      <p class="fw-bold">Neuer Drucker</p>
      <div class="flex w-full flex-col">
        <label class="mt-2 block text-sm font-medium leading-6 text-gray-900" for="name">Name</label>
        <div class="mt-0.5">
          <input [(ngModel)]="name" (ngModelChange)="filter()" autocomplete="printer-name"
                 class="block w-full rounded-md p-1.5 text-gray-900 shadow-sm border-2 border-b-gray-300 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                 id="name"
                 name="name"
                 type="text">
        </div>
        <label class="mt-2 block text-sm font-medium leading-6 text-gray-900" for="connection-string">Verbindungszeichenfolge</label>
        <div class="mt-0.5">
          <input [(ngModel)]="connectionString" autocomplete="printer-connection-string"
                 class="block w-full rounded-md p-1.5 text-gray-900 shadow-sm border-2 border-b-gray-300 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                 id="connection-string"
                 name="connection-string"
                 placeholder="[IP / Hostname]:[Port]"
                 type="text">
        </div>
      </div>
      <button (click)="add()"
              class="mt-3 rounded-md bg-gray-800 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-600"
              type="button">
        Hinzufügen
      </button>
    </div>
    <ul class="xl:col-span-3 divide-y divide-gray-100 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3"
        role="list">
      <li *ngFor="let printer of filtered" class="p-4 flex rounded-lg shadow-xl space-x-4">
        <div class="flex w-full justify-between gap-x-6">
          <div class="flex min-w-0 gap-x-4">
            <svg height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 17v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2M7 17v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2M7 17H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1m0 0V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2M6 7h12m0 0h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2M7 10h1"
                fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2"/>
            </svg>
            <div class="min-w-0 flex-auto">
              <p class="text-sm font-semibold leading-6 text-gray-900">{{ printer.name }}</p>
              <p class="mt-1 truncate text-xs leading-5 text-gray-500">{{ printer.connectionString }}</p>
            </div>
          </div>
          <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
            <p class="text-sm leading-6 text-gray-900">
              @switch (printer.type) {
                @case (PrinterType.Thermo) {
                  <span>Thermodrucker</span>
                }
                @default {
                  <span>Standard</span>
                }
              }
            </p>
            <p class="mt-1 text-xs leading-5 text-gray-500">Geändert: {{ printer.modified | date }}</p>
          </div>
        </div>
        <div>
          @if (PermissionService.CheckPermission(PermissionService.Device_Printer_Get())) {
            <a (click)="toSettings(printer.id)"
               class="h-8 w-8">
              <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-9 9A1 1 0 0 1 11 17H8a1 1 0 0 1-1-1v-3a1 1 0 0 1 .293-.707zM9 13.414V15h1.586l8-8L17 5.414zM3 7a2 2 0 0 1 2-2h5a1 1 0 1 1 0 2H5v12h12v-5a1 1 0 1 1 2 0v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                />
              </svg>
            </a>
          }
        </div>
      </li>
    </ul>
  </div>
</div>
